import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Option from './option'

const propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    selectable: PropTypes.bool,
    selected: PropTypes.bool
}

const defaultProps = {
    onClick() {},
    selectable: false
}

function Placeholder(props) {
    const { children, className, onClick, selectable, selected } = props
    const mergedProps = { selectable }
    const classNameMerged = cx('t3sel-placeholder', className)
    if (selectable) {
        mergedProps.onClick = onClick
        mergedProps.selected = selected
    }

    return (
        <Option {...mergedProps} className={classNameMerged}>
            {children}
        </Option>
    )
}

Placeholder.propTypes = propTypes
Placeholder.defaultProps = defaultProps

export default Placeholder
